import React from 'react';

import CommonImage from '@/components/CommonImage';
const MaterialReqisitionTable = () => {
	return (
		<>
			<div className="topheader">
				<div className="filter-container-top block-library-filter-top d-block pt-2 pb-2">
					<div className="d-flex align-items-center justify-content-between">
						<div className="filters">
							<div className="filter-toggle">
								<CommonImage src="/icons/filter24.svg" alt="filter" />

								<span>Filter</span>
							</div>
							<ul className="common-list-component mt-1 mr-2">
								<li>
									<span className="regular-14 gray_dark_02 weight-500">
										Total inventory: 6 Items
									</span>
								</li>
								<li>
									<span className="regular-14 gray_dark_02 weight-500">
										Knit (Jersey): 858 KG & 5 Items
									</span>
								</li>
								<li>
									<span className="regular-14 gray_dark_02 weight-500">
										Woven: 6 YRD, 1 Items
									</span>
								</li>
								<li>
									<span className="regular-14 gray_dark_02 weight-500">
										Denim: 0 YRD, 0 Items
									</span>
								</li>
							</ul>
						</div>

						<div className="filter-actions sample-dashboard-filter">
							<div className="form-group size32 m-0 search-filter filter-with-animation">
								<div className="with-icon right-icon">
									<input
										type="text"
										placeholder=""
										name="name"
										autoComplete="off"
										value=""
									/>
									<span className="right-icon">
										<CommonImage
											src="/icons/search-dark.svg"
											alt="Search icon"
											width={23}
											height={22}
										/>
									</span>
								</div>
							</div>

							<div className="sort-button design-view-sort mt-1">
								<button className="button size32">Request Material</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<section className="filter-data-container filter-v3-data-container bg-white">
				<div className="data-table expand">
					<table className="table requisition-table with-border height-sm hover">
						<thead>
							<tr>
								<th>Requisition details</th>
								<th>Brands</th>
								<th>Required within</th>
								<th>Fabric type</th>
								<th>Colors</th>
								<th>Status</th>
								<th>Remarks</th>
								<th>Attachments</th>
								<th>Action</th>
								<th>Approval Stages</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td className="requisition-details-column">
									<p className="regular-14 gray_dark_02">Ziaul Haque - 25 Mar, 2024</p>
								</td>
								<td className="brands-column">
									<p className="regular-14 gray_dark_02">Zalando, Next</p>
								</td>
								<td className="required-within-column">
									<p className="regular-14 gray_dark_02">7th April 2025</p>
								</td>
								<td className="fabric-type-column">
									<p className="regular-14 gray_dark_02">Knit</p>
								</td>
								<td
									className="colors-column"
									style={{ backgroundColor: 'green', color: 'white' }}
								>
									<p className="regular-14">TX-ABCD</p>
								</td>
								<td className="status-column">
									<div className="d-flex flex-column fjustify-content-start align-items-start gap-2">
										<span className="status red-1">Sent for Approval</span>
										<span className="status green-1">Sent for Approval</span>
										<span className="status yellow-1">Sent for Approval</span>
									</div>
								</td>
								<td className="remarks-column">
									<p className="regular-14 gray_dark_02">Color : TX - CC113</p>
								</td>
								<td className="attachments-column">
									<span className="blue regular-14 text-underline cursor-pointer">
										Trend board
									</span>
									<span className="blue regular-14 text-underline ml-2 cursor-pointer">
										Range plan
									</span>
								</td>
								<td className="action-column">
									<div className="d-flex flex-column fjustify-content-start align-items-start gap-2">
										<span className="blue regular-14 text-underline cursor-pointer">
											View Materials
										</span>
										<span className="blue regular-14 text-underline cursor-pointer">
											View Inventory
										</span>
										<span className="blue regular-14 text-underline cursor-pointer">
											Send for Approval
										</span>
									</div>
								</td>
								<td className="approval-stages-column">
									<div className="d-flex flex-wrap fjustify-content-start align-items-start gap-2">
										<div className="custom-chekbox">
											<div className="form-group">
												<input
													type="checkbox"
													id="s"
													name=""
													value=""
													className="custom-checkbox-input"
												/>
												<label
													className="regular-14 d-flex gray_dark_02 align-items-center"
													htmlFor="s"
												>
													<span>Accounts</span>
												</label>
											</div>
										</div>
										<div className="custom-chekbox">
											<div className="form-group">
												<input
													type="checkbox"
													id="s"
													name=""
													value=""
													className="custom-checkbox-input"
												/>
												<label
													className="regular-14 d-flex gray_dark_02 align-items-center"
													htmlFor="s"
												>
													<span>Accounts</span>
												</label>
											</div>
										</div>
										<div className="custom-chekbox">
											<div className="form-group">
												<input
													type="checkbox"
													id="s"
													name=""
													value=""
													className="custom-checkbox-input"
												/>
												<label
													className="regular-14 gray_dark_02 d-flex align-items-center"
													htmlFor="s"
												>
													<span>Accounts</span>
												</label>
											</div>
										</div>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</section>
		</>
	);
};

export default MaterialReqisitionTable;
